import { CargoForm } from '@presentation/components/organisms'
import { AddModal } from '@presentation/components/templates'
import { AddModalProps } from '@presentation/types/components/templates'

import { validationSchema } from './shared'

type Props = {
  onAdd: () => void
}

const AddCargoModal: React.FC<Props> = ({ onAdd }) => {
  const modalConfigs: AddModalProps = {
    path: '/cargos',
    formId: 'add-cargo',
    nameForTitle: 'Cargo',
    validationSchema,
    onAdd
  }

  return (
    <AddModal {...modalConfigs}>
      <CargoForm />
    </AddModal>
  )
}

export default AddCargoModal
